interface ButtonProps {
  text: string
  classes?: string
  action?: (e: any) => void
  disabled?: boolean
  loading?: boolean
  loadingText?: string
  type?: 'button' | 'submit' | 'reset'
}

const Button = ({
  text,
  classes = '',
  action,
  disabled = false,
  loading = false,
  loadingText = 'Loading...',
  type = 'button',
}: ButtonProps) => {
  const defaultClass =
    'bg-black text-white w-32 h-10 rounded transition-none disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:scale-100 disabled:pointer-events-none'
  const isDisabled = disabled || loading

  return (
    <button
      type={type}
      className={`${defaultClass} ${classes}`}
      onClick={isDisabled ? undefined : action}
      disabled={isDisabled}
    >
      {loading ? loadingText : text}
    </button>
  )
}

export default Button
